import { render } from "./SubmitButton.vue?vue&type=template&id=48782575&scoped=true"
import script from "./SubmitButton.vue?vue&type=script&lang=ts"
export * from "./SubmitButton.vue?vue&type=script&lang=ts"

import "./SubmitButton.vue?vue&type=style&index=0&id=48782575&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-48782575"

export default script